<template>
    <div class="flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
                class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
            >
                <table class="relative min-w-full divide-y divide-taupe-300">
                    <slot />
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
defineOptions({
    name: 'ZenGridTable',
})
</script>
